import React from 'react';
import {
  Row, Col, Button, Input,
  Label, CustomInput
} from 'reactstrap';

const FiltrosConfig = ({ state, setState }) => {

  const updateField = (field, key, newVal) => {
    let Filters = [...state.Filters];
    Filters.forEach(f => {
      if (f.key === key) {
        f[field] = newVal;
      }
    });
    Filters = Filters.sort((a, b) => (a.orden - b.orden));
    Filters.forEach((item, index) => (item.orden = (index)));

    setState({ Filters: Filters });

  }

  return (
    <Row>
      {
        state.Filters.sort((a, b) => (a.orden - b.orden)).map((item, index) => (
          <Col xs={12} key={`filter-${item.key}`}>
            <hr className='p-0 m-1' />
            <Row>
              {/* <Col className="my-auto pr-0"><Label></Label></Col> */}
              <Col className="my-auto">
                {`${item.orden + 1}. ${item.key} `}
                <Input
                  type="text"
                  value={item.nameToDisplay}
                  onChange={(evt => {
                    evt.preventDefault();
                    updateField("nameToDisplay", item.key, evt.target.value);
                  })}
                  placeholder="Nombre Visible"
                />
              </Col>
              <Col xs={3} className="my-auto">
                <CustomInput
                  type="checkbox"
                  id={`Filtro-${item.key}`}
                  label="Aplicar"
                  checked={item.enabled}
                  onClick={(evt) => {
                    evt.preventDefault();
                    setTimeout(() => updateField("enabled", item.key, !!!item.enabled), 100);
                  }}
                />
              </Col>
              <Col xs={4} className="my-auto">
                <Button color="primary" size="sm" onClick={() => updateField("orden", item.key, item.orden - 2)} className={index > 0 ? "mx-1 visible cursor-pointer" : "mx-1 invisible"}><i className="fa fa-arrow-up" aria-hidden="true"></i></Button>
                <Button color="primary" size="sm" onClick={() => updateField("orden", item.key, item.orden + 2)} className={index < (state.length - 1) ? "visible cursor-pointer" : "invisible"}><i className="fa fa-arrow-down" aria-hidden="true"></i></Button>
              </Col>
            </Row>
          </Col>
        ))
      }
    </Row>
  )
}

export default FiltrosConfig;


// WEBPACK FOOTER //
// ./src/views/Gestion/Sitio/Configuracion/FiltrosConfig.js